import React, { useState, useMemo } from 'react';
import { doc, updateDoc, increment, serverTimestamp } from 'firebase/firestore';
import toasted from '../config/toasted';
import { GeneratingTokens } from '@mui/icons-material';

const DailyReward = ({ userData, db }) => {

     const [rewardInfo, setRewardInfo] = useState(null);

     const canClaim = useMemo(() => {
          if (rewardInfo) return false;

          const lastClaim = userData?.dailyClaimAt?.seconds || 0;
          const now = new Date();

          const today9AM = new Date();
          today9AM.setHours(9, 0, 0, 0);

          const lastClaimDate = new Date(lastClaim * 1000);

          if (now >= today9AM) {
               return lastClaimDate < today9AM;
          } else {
               const yesterday9AM = new Date(today9AM);
               yesterday9AM.setDate(yesterday9AM.getDate() - 1);
               return lastClaimDate < yesterday9AM;
          }
     }, [userData?.dailyClaimAt, rewardInfo]);

     const handleDailyClaim = async () => {
          try {
               const reward = userData?.subscriptions === "paid" ? 50 : 20;
               const userRef = doc(db, "users", userData.uid);

               await updateDoc(userRef, {
                    generation_credits: increment(reward),
                    dailyClaimAt: serverTimestamp()
               });

               setRewardInfo(reward);
               toasted.success(`+${reward} credits added`);
          } catch (error) {
               toasted.error("Failed to claim. Try again!");
          }
     };


     return (
          <div className='col-12'>
               <div className="daily-reward-card">

                    <div className="daily-reward-info">
                         <GeneratingTokens />

                         <div className="daily-reward-text">
                              <h6>Daily Reward</h6>
                              <p>Collect your free daily credits</p>
                         </div>
                    </div>

                    <div className="daily-reward-action">
                         {canClaim ? (
                              <button className="daily-claim-btn" onClick={handleDailyClaim}>
                                   Claim Credits
                              </button>
                         ) : (
                              <span className="daily-wait">Come back after 9:00 AM</span>
                         )}
                    </div>

               </div>

          </div>



     );
};

export default DailyReward;